import React, { useEffect, useState } from 'react'
import RightModal from '../../../components/Modals/RightModal'
import InputTextarea from '../../../components/InputGroup/InputTextarea';
import InputSelect from '../../../components/InputGroup/InputSelect';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import CenterModal from '../../../components/Modals/center-modal';
import InputText from '../../../components/InputGroup/InputText';
import MobileInput from '../../../components/InputGroup/MobileInput';
// import { ReactComponent as CloseIcon } from '../../../assets/close.svg';
import { ReactComponent as LocationIcon } from '../../../assets/icons/location.svg';
import { ReactComponent as TokenIcon } from '../../../assets/icons/token.svg';
import { getProjects } from '../../../services/private/company.service';
import { tokenRequest } from '../../../services/private/plus.leads.service';

const RequestToken = ({ show, closeModal, handleGetLeads }) => {
    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [project, setProjects] = useState([]);
    const [commnets, setComments] = useState('');
    const [projectList, setProjectList] = useState([])
    const [error, setError] = useState('');

    const getAllProjects = async () => {

        await getProjects({}, '').then((res) => {
            if (res.status === 200) {
                console.log(res.data.data, 'data')
                let projects = res.data.data.map(i => ({ ...i, label: i.name, value: i.uuid }));
                setProjectList(projects)
            }
        }).catch((err) => {
            console.log("Something went wrong", err);
        })
    }

    useEffect(() => {
        getAllProjects()
    }, []);

    const handleSubmit = async () => {
        if (!name || !mobile || project.length === 0) {
            setError(true);
            return;
        } else {
            setError(false)
        }

        const payload = {
            customer_name: name,
            customer_mobile: mobile,
            project_ids: project.map(i => i.value), //need to discuss this with ankit
            remarks: commnets,
        }

        const res = await tokenRequest(payload);
        if (res.data.status === 200) {
            console.log(res.data.message);
            handleGetLeads();
            closeModal();
        }
    }

    return (
        <CenterModal show={show} closeModal={closeModal} modalClass='!w-[560px]  [&>*]:!border-0 [&>*]:!rounded-xl [&>*]:!overflow-hidden'>
            <div className='!p-6'>
                <div className={`d-flex align-items-center justify-content-between`}>
                    {/* <h2 className='fz18 black fw-po-medium mb-0 inter'>Project Added to your list</h2> */}
                    <div className='h-12 w-12 rounded-xl bg-[#5256FB] flex items-center justify-center'>
                        <TokenIcon className='fill-white h-6 w-6' />
                    </div>
                    <button onClick={closeModal} className='border-0 bg-tr'><CloseIcon /></button>
                </div>
                <div className='!mt-4'>
                    <h1 className='m-0 text-lg font-semibold'>Add Token Request</h1>
                </div>
                <div className='grid grid-cols-2 !gap-2'>
                    <div className='col-span-2'>
                        <InputText
                            label={'Name'}
                            placeholder={'e.g. Rahul'}
                            inputclass={'!mb-0'}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            error={error && !name ? 'Please Enter Name' : ''}
                        />
                    </div>
                    <MobileInput
                        label='Mobile'
                        value={mobile}
                        onChange={(e) => setMobile(e.phone)}
                        error={(error && !mobile) ? 'Please Enter Mobile' : ''}
                        // disable={userMobile ? true : false}
                        inputclass='!h-10 !w-full !mb-0'
                    />
                    <InputSelect
                        label={'Projects'}
                        value={project}
                        onChange={(value) => setProjects(value)}
                        error={(error && project.length === 0) ? 'Please Select Project' : ''}
                        options={projectList}
                        isMulti={true}
                    />

                    <div className='col-span-2'>
                        <InputTextarea
                            label={'Comments'}
                            inputclass={'!mb-0'}
                            value={commnets}
                            onChange={(e) => setComments(e.target.value)}
                        />
                    </div>

                </div>
                <div className='w-full flex !gap-4 !mt-4'>
                    <button className='w-1/2 border py-2 text-black700 rounded-lg'>Cancel</button>
                    <button
                        className='w-1/2 gradient-blue text-white py-2 rounded-lg font-medium'
                        onClick={handleSubmit}
                    >Submit</button>

                </div>
            </div>
        </CenterModal>
    )
}

export default RequestToken